<!--<p class="text-start fst-italic" [innerHtml]="global_texts.many_answers_possible"></p>-->


<div *ngIf="question.answers_options.length <= 5">
  <label class="custom-checkbox d-flex align-items-center" *ngFor="let answer of question.answers_options">
    <input type="checkbox" id="checkbox{{answer.id}}" [attr.name]="'checkbox_' + answer.id"
           [(ngModel)]="answer.selected"
           [disabled]="disabled"
           (change)="onAnswerChange()" [checked]="answer.selected">
    <span class="checkmark"></span>
    <span class="text-label-custom-checkbox" [innerHtml]="answer.label"></span>
  </label>
</div>

<div *ngIf="question.answers_options.length > 5">
  <div class="d-flex flex-column flex-md-row gap-3">
    <div>
      <label class="custom-checkbox d-flex align-items-center" *ngFor="let answer of question.answers_options; let i = index"
             [ngClass]="{'d-none': i >= question.answers_options.length / 2}">
        <input type="checkbox" id="checkbox{{answer.id}}" [attr.name]="'checkbox_' + answer.id"
               [(ngModel)]="answer.selected"
               [disabled]="disabled"
               (change)="onAnswerChange()" [checked]="answer.selected">
        <span class="checkmark"></span>
        <span class="text-label-custom-checkbox" [innerHtml]="answer.label"></span>
      </label>
    </div>
    <div>
      <label class="custom-checkbox d-flex align-items-center" *ngFor="let answer of question.answers_options; let i = index"
             [ngClass]="{'d-none': i < question.answers_options.length / 2}">
        <input type="checkbox" id="checkbox{{answer.id}}" [attr.name]="'checkbox_' + answer.id"
               [(ngModel)]="answer.selected"
               [disabled]="disabled"
               (change)="onAnswerChange()" [checked]="answer.selected">
        <span class="checkmark"></span>
        <span class="text-label-custom-checkbox" [innerHtml]="answer.label"></span>
      </label>
    </div>

  </div>
</div>

